import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchaseNotices } from '../data/notifications';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 5200;
const GAP_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: number;
    let hideTimer: number;
    const cycle = (delay: number) => {
      showTimer = window.setTimeout(() => {
        setVisible(true);
        hideTimer = window.setTimeout(() => {
          setVisible(false);
          setIndex(prev => (prev + 1) % purchaseNotices.length);
          cycle(GAP_MS);
        }, VISIBLE_MS);
      }, delay);
    };
    cycle(FIRST_DELAY);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  if (dismissed) return null;
  const notice = purchaseNotices[index];
  return <div aria-live="polite" className={`fixed bottom-24 left-3 z-30 max-w-[290px] transition-[transform,opacity] duration-200 ease-out sm:bottom-28 sm:left-5 sm:max-w-[330px] ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-2 opacity-0'}`} data-id="element-47" data-mp="164obkbkmsdwt">
      <div className="flex items-start gap-3 rounded-xl border border-white/10 bg-ink-800 p-3 shadow-[0_18px_40px_-16px_rgba(0,0,0,0.9)]" data-id="element-48" data-mp="1ay0mxk0auo7m">
        <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-accent/15" data-id="element-49" data-mp="n8y62edhoze6">
          <ShoppingBagIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-50" data-mp="x5b1bgoonlb1" />
        </span>
        <div className="min-w-0" data-id="element-51" data-mp="x2ybkhcoo6nf">
          <p className="text-[13px] font-semibold leading-snug text-white" data-id="element-52" data-mp="s5yc4paca25a">
            {notice.name} <span className="font-normal text-white/60" data-id="element-53" data-mp="28jy8jq9z79ns">ha appena acquistato</span>
          </p>
          <p className="text-[12px] font-semibold leading-snug text-accent" data-id="element-54" data-mp="23lwi2ka8082a">
            Sistema Tecnico PRO 360™
          </p>
          <p className="mt-0.5 truncate text-[11px] text-white/40" data-id="element-55" data-mp="2anrur3odj6gw">
            {notice.place} · pochi istanti fa
          </p>
        </div>
        <button type="button" onClick={() => setDismissed(true)} aria-label="Chiudi notifica" className="-mr-1 -mt-1 rounded p-1 text-white/35 transition-colors duration-150 ease-out hover:text-white" data-id="element-56" data-mp="2fphb8yud8ccd">
          <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-57" data-mp="1rz4vj1svpbb8" />
        </button>
      </div>
    </div>;
}